import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { AdminEditorService } from '../../admin.service';
import { EnumToComboValues, GridColumnHelper } from '../utils';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { MediaDetailsSectionHandler } from './details.section';
import { Observable, timer } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';
import { MEDIA_STATES, NamedMediaResponse } from './model';
import { MediaSectionHandler } from '../shared/media.section';


@RegisterEntityHandler('media')
@Injectable()
export class MediaHandler extends EntityHandler<NamedMediaResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = [];
    items: EntityListResult;
    changesVisible = false;
    filterEnabled = false;

    async listEntities(ownerId: string, offset: number, limit: number, sort: string, _filter: string): Promise<EntityListResult> {
        this.items = await this.admin.getCached(`listMedia/${ownerId}/${offset}/${limit}/${sort}/${_filter}`, api => api.media.listMedia(ownerId, offset, limit), 3).then(response => ({
            ...response,
            type: 'media',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.MEDIA'),
        }));
        return this.items;
    }

    getEntity(id: string): Observable<NamedMediaResponse> {
        let isDone = false;
         return timer(0, 5000).pipe( // poll the backend every 5 seconds
             switchMap(() => this.admin.getCached(`getMedia/${id}`, api => api.media.getMedia(id).then(x => ({ name: x.asset.name, ...x })), 1)),
             filter(value => {
                 if (isDone) {
                     return false;
                 }
                 isDone = ['ready', 'failed'].includes(value.status);
                 return true;
             })
         );
    }

    async createEntity(_ownerId: string, _entity: any): Promise<NamedMediaResponse> {
        throw new Error('Not implemented');
    }

    async setEntityState(_entity: any, _state: string): Promise<any> {
        throw new Error('Not implemented');
    }

    async getGridColumns(_ownerId: string): Promise<IKuiTableCol[]> {
        const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.MEDIA.COLUMNS');

        const columns: IKuiTableCol[] = [
            grid.IconTextColumn('date', 'DATE', ICONS.media),
            grid.IdNameTextColumn('asset', 'ASSET', 120),
            grid.IdNameTextColumn('requester', 'REQUESTER', 120),
            grid.TextColumn('input', 'INPUT', 100),
            grid.TextColumn('duration', 'DURATION', 70),
            grid.ComboColumn('status', 'STATUS', EnumToComboValues(this.admin.i18n, 'ADMIN.EDITORS.MEDIA.STATUS', MEDIA_STATES, []), 80),
        ];
        columns.push(grid.TimeAgoColumn('entity.modifiedDate', 'REQUESTED'));
        return columns;
    }

    getEditorSections(ownerId: string, entity: NamedMediaResponse): Promise<SectionHandlerGroup<NamedMediaResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new MediaDetailsSectionHandler(this.admin, ownerId, false),
                entity && entity.status === 'ready' && new MediaSectionHandler(this.admin),
            ].filter(x => x),
        }]);
    }

    async getCreationSections(_ownerId: string): Promise<{ entityType: string, entity: any, sections: FormSectionHandler<any, any>[] }> {
        return null;
    }

}













